export default [
    {
        name: 'islandModel1',
        type: 'gltfModel',
        path: './models/Environment/Isla_InstAereav2.glb'
    },
    {
        name: 'islandModel2',
        type: 'gltfModel',
        path: './models/Environment/Isla_InstSubv2.glb'
    },
    {
        name: 'islandModel3',
        type: 'gltfModel',
        path: './models/Environment/Isla_InstUMillav2.glb'
    },
    {
        name: 'islandModel4',
        type: 'gltfModel',
        path: './models/Environment/Isla_InstCDatosv2.glb'
    },
    {
        name: 'islandModel5',
        type: 'gltfModel',
        path: './models/Environment/Isla_InstCEstrucv2.glb'
    },
    {
        name: 'islandModel6',
        type: 'gltfModel',
        path: './models/Environment/Isla_FIB2Uv2.glb'
    },
    {
        name: 'cloudModel',
        type: 'gltfModel',
        path: './models/Environment/Clouds.glb'
    },
    {
        name: 'segmentModel1A',
        type: 'gltfModel',
        path: './models/Environment/Env_InstAerea.glb'
    },
    {
        name: 'segmentModel1B',
        type: 'gltfModel',
        path: './models/Environment/Env_InstAerea_Cat.glb'
    },
    {
        name: 'islandTexture1',
        type: 'texture',
        path: './models/Environment/Isla_InstAereav2Bake.jpg'
    },
    {
        name: 'islandTexture2',
        type: 'texture',
        path: './models/Environment/Isla_InstSubv2Bake.jpg'
    },
    {
        name: 'islandTexture3',
        type: 'texture',
        path: './models/Environment/Isla_InstUMillav2.jpg'
    },
    {
        name: 'islandTexture4',
        type: 'texture',
        path: './models/Environment/Isla_InstCDatosV2Bake.jpg'
    },
    {
        name: 'islandTexture5',
        type: 'texture',
        path: './models/Environment/Isla_InstCEstrucv2Bake.jpg'
    },
    {
        name: 'backgroundTexture',
        type: 'texture',
        path: './images/bgGradient.png'
    },    
    {
        name: 'islandTexture6',
        type: 'texture',
        path: './models/Environment/Isla_FIB2Uv2Bake.jpg'
    },
    {
        name: 'cloudTexture',
        type: 'texture',
        path: './models/Environment/CloudBake1024.jpg'
    },
    {
        name: 's1ATexture',
        type: 'texture',
        path: './models/Environment/IA_Land_Bake.jpg'
    },
    {
        name: 's1BTexture',
        type: 'texture',
        path: './models/Environment/IA_Plants_Bake.jpg'
    },
    {
        name: 's1CTexture',
        type: 'texture',
        path: './models/Environment/IA_Props_Bake.jpg'
    },
    {
        name: 's1DTexture',
        type: 'texture',
        path: './models/Environment/IA_Clouds_Bake.jpg'
    },
    {
        name: 's1ETexture',
        type: 'texture',
        path: './models/Environment/IA_World_Bake.jpg'
    },
    {
        name: 'segmentModel2A',
        type: 'gltfModel',
        path: './models/Environment/Env_InstSub.glb'
    },
    {
        name: 'segmentModel2B',
        type: 'gltfModel',
        path: './models/Environment/Env_InstSub_Cat.glb'
    },
    {
        name: 's2ATexture',
        type: 'texture',
        path: './models/Environment/ISub_World_Bake.jpg'
    },
    {
        name: 's2BTexture',
        type: 'texture',
        path: './models/Environment/ISub_Tubes_Carrete_Bake.jpg'
    },
    {
        name: 's2CTexture',
        type: 'texture',
        path: './models/Environment/ISub_Props_Bake.png'
    },
    {
        name: 's2DTexture',
        type: 'texture',
        path: './models/Environment/ISub_Road_Bake.jpg'
    },
    {
        name: 's2ETexture',
        type: 'texture',
        path: './models/Environment/ISub_Clouds_Bake.jpg'
    },
    {
        name: 's2FTexture',
        type: 'texture',
        path: './models/Environment/ISub_Plants_Bake.jpg'
    },
    {
        name: 'segmentModel3A',
        type: 'gltfModel',
        path: './models/Environment/Env_UltMilla.glb'
    },
    {
        name: 'segmentModel3B',
        type: 'gltfModel',
        path: './models/Environment/Env_UltMilla_Cat.glb'
    },
    {
        name: 's3ATexture',
        type: 'texture',
        path: './models/Environment/UltMilla_City_Bake.jpg'
    },
    {
        name: 's3BTexture',
        type: 'texture',
        path: './models/Environment/UltMilla_Postes_Bake.jpg'
    },
    {
        name: 's3CTexture',
        type: 'texture',
        path: './models/Environment/UltMilla_SOBuildings_Bake.jpg'
    },
    {
        name: 's3DTexture',
        type: 'texture',
        path: './models/Environment/UltMilla_Road_Bake.jpg'
    },
    {
        name: 's3ETexture',
        type: 'texture',
        path: './models/Environment/UltMilla_Clouds_Bake.jpg'
    },
    {
        name: 's3FTexture',
        type: 'texture',
        path: './models/Environment/UltMilla_Plant_Bake.jpg'
    },
    {
        name: 's3GTexture',
        type: 'texture',
        path: './models/Environment/UltMilla_World_Bake.jpg'
    }
    ,
    {
        name: 'segmentModel4A',
        type: 'gltfModel',
        path: './models/Environment/Env_CDatos.glb'
    },
    {
        name: 'segmentModel4B',
        type: 'gltfModel',
        path: './models/Environment/Env_CDatos_Cat.glb'
    },
    {
        name: 's4ATexture',
        type: 'texture',
        path: './models/Environment/CDatos_FIBERWAY_Bake.jpg'
    },
    {
        name: 's4BTexture',
        type: 'texture',
        path: './models/Environment/CDatos_Gabinete_CE_Bake.jpg'
    },
    {
        name: 's4CTexture',
        type: 'texture',
        path: './models/Environment/CDatos_Gabinete_DC_Bake.jpg'
    },
    {
        name: 's4DTexture',
        type: 'texture',
        path: './models/Environment/CDatos_Lamps_Bake.jpg'
    },
    {
        name: 's4ETexture',
        type: 'texture',
        path: './models/Environment/CDatos_Rack_Bake.jpg'
    },
    {
        name: 's4FTexture',
        type: 'texture',
        path: './models/Environment/CDatos_Room1_Bake.jpg'
    },
    {
        name: 's4GTexture',
        type: 'texture',
        path: './models/Environment/CDatos_Room2_Bake.jpg'
    },
    {
        name: 'segmentModel5A',
        type: 'gltfModel',
        path: './models/Environment/Env_CEstructurado.glb'
    },
    {
        name: 'segmentModel5B',
        type: 'gltfModel',
        path: './models/Environment/Env_CEstructurado_Cat.glb'
    },
    {
        name: 's5ATexture',
        type: 'texture',
        path: './models/Environment/CEstructurado_Plants_Bake.jpg'
    },
    {
        name: 's5BTexture',
        type: 'texture',
        path: './models/Environment/CEstructurado_Clouds_Bake.jpg'
    },
    {
        name: 's5CTexture',
        type: 'texture',
        path: './models/Environment/CEstructurado_World_Bake.jpg'
    },
    {
        name: 's5DTexture',
        type: 'texture',
        path: './models/Environment/CEstructurado_Building1_Bake.jpg'
    },
    {
        name: 's5ETexture',
        type: 'texture',
        path: './models/Environment/CEstructurado_Building2_Bake.jpg'
    },
    {
        name: 's5FTexture',
        type: 'texture',
        path: './models/Environment/CEstructurado_Servers_Bake.jpg'
    },
    {
        name: 's5GTexture',
        type: 'texture',
        path: './models/Environment/CEstructurado_Doors_Desks_Bake.jpg'
    },
    {
        name: 's5HTexture',
        type: 'texture',
        path: './models/Environment/CEstructurado_Computers_Bake.jpg'
    },
    {
        name: 'segmentModel6A',
        type: 'gltfModel',
        path: './models/Environment/Env_FIB2U.glb'
    },
    {
        name: 'segmentModel6B',
        type: 'gltfModel',
        path: './models/Environment/Env_FIB2U_Cat.glb'
    },
    {
        name: 's6ATexture',
        type: 'texture',
        path: './models/Environment/FIB2U_Building1_Bake.jpg'
    },
    {
        name: 's6BTexture',
        type: 'texture',
        path: './models/Environment/FIB2U_Building2_Bake.jpg'
    },
    {
        name: 's6CTexture',
        type: 'texture',
        path: './models/Environment/FIB2U_Building3_Bake.jpg'
    },
    {
        name: 's6DTexture',
        type: 'texture',
        path: './models/Environment/FIB2U_Clouds_Bake.jpg'
    },
    {
        name: 's6ETexture',
        type: 'texture',
        path: './models/Environment/FIB2U_Computers_Bake.jpg'
    },
    {
        name: 's6FTexture',
        type: 'texture',
        path: './models/Environment/FIB2U_Doors_Desks_Bake.jpg'
    },
    {
        name: 's6GTexture',
        type: 'texture',
        path: './models/Environment/FIB2U_Plants_Bake.jpg'
    },
    {
        name: 's6HTexture',
        type: 'texture',
        path: './models/Environment/FIB2U_Racks_Postes_Bake.jpg'
    },
    {
        name: 's6ITexture',
        type: 'texture',
        path: './models/Environment/FIB2U_World_Bake.jpg'
    }
]